import Vue from 'vue'
import VueRouter from 'vue-router'
import Search from '../views/Search.vue'
import Results from '../views/Results.vue'
import ResultList from '../views/ResultList.vue'
import ResultDetail from '../views/ResultDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'search',
    component: Search
  },
  {
    path: '/s/:trackingNumber',    
    component: Results,
    children: [
      {
        path: '',
        name: 'results',
        component: ResultList
      },
      {
        path: 'd/:id',
        name: 'resultDetail',
        component: ResultDetail
      }
    ]
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return {x: 0, y: 0}
  }
})

export default router
